// extracted by mini-css-extract-plugin
export default {"root":"NoSubscribe_root__KmL5n"};